import type { ReactNode } from 'react'
import { useState } from 'react'

import * as TooltipRadix from '@radix-ui/react-tooltip'
import { TooltipContentProps } from '@radix-ui/react-tooltip'
import type { CSSProps, VariantProps } from 'style'

import TooltipContentStyled, { ArrowStyled } from './tooltip.styled'

import { FCC } from 'types/react'

type TooltipVariants = VariantProps<typeof TooltipContentStyled>
type TooltipCustomProps = {
  text: ReactNode
  open?: boolean
  delayDuration?: number
}

type TooltipProps = TooltipCustomProps &
  TooltipContentProps &
  TooltipVariants &
  CSSProps

const Tooltip: FCC<TooltipProps> = props => {
  const { children, open, type, text, delayDuration, ...rest } = props
  return (
    <TooltipRadix.Root open={open} delayDuration={delayDuration}>
      <TooltipRadix.Trigger asChild>{children}</TooltipRadix.Trigger>
      {!!text && (
        <TooltipContentStyled
          type={type}
          {...rest}
          sideOffset={10}
          css={{ bgc: '$bgCard' }}
        >
          {rest.side === 'bottom' && (
            <ArrowStyled
              css={{
                fill: '$bgCard',
              }}
            />
          )}
          {text}
          {rest.side !== 'bottom' && (
            <ArrowStyled
              css={{
                fill: '$bgCard',
              }}
            />
          )}
        </TooltipContentStyled>
      )}
    </TooltipRadix.Root>
  )
}

export const TooltipMobile: FCC<TooltipProps> = props => {
  const [open, setOpen] = useState(false)
  const { children, type, text, delayDuration, ...rest } = props

  return (
    <TooltipRadix.Root open={open} delayDuration={delayDuration}>
      <TooltipRadix.Trigger asChild onClick={() => setOpen(!open)}>
        {children}
      </TooltipRadix.Trigger>
      {!!text && (
        <TooltipContentStyled type={type} {...rest} sideOffset={10}>
          {rest.side === 'bottom' && <ArrowStyled />}
          {text}
          {rest.side !== 'bottom' && <ArrowStyled />}
        </TooltipContentStyled>
      )}
    </TooltipRadix.Root>
  )
}

Tooltip.defaultProps = {
  side: 'top',
  delayDuration: 300,
}

export default Tooltip
